document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector(".mobile-sticky-nav");
  const stickyHeaderEle = document.querySelector('.shopify-section-header-sticky');
  const menuTrigger = document.querySelector('.menu-drawer__trigger-button');
  const menuDetailsEle = document.querySelector('#Details-menu-drawer-container');
  const menuSummary = document.querySelector('#Details-menu-drawer-container summary');
  const drawerCloseButton = document.querySelector('.drawer-close__button');

  menuTrigger?.addEventListener('click', () => {
    menuDetailsEle?.classList.add('menu-opening');
    menuDetailsEle?.setAttribute('open', true);
    menuSummary?.setAttribute('aria-expanded', true);
    document.body.classList.add('nav-overflow-hidden');
  })

  drawerCloseButton?.addEventListener('click', () => {
    menuDetailsEle?.classList.remove('menu-opening');
    menuDetailsEle?.removeAttribute('open');
    menuSummary?.setAttribute('aria-expanded', false);
    document.body.classList.remove('nav-overflow-hidden');
  })

  document.addEventListener('click', (event) => {
    if (event.target.closest('.take-test__wrapper')) {
      document.body.classList.remove('nav-overflow-hidden');
    }
  })


  const cartTrigger = document.querySelector('.cart-drawer__trigger');
  const cartDrawerEle = document.querySelector('#cart-icon-bubble');

  cartTrigger?.addEventListener('click', () => {
    cartDrawerEle?.click();
  })

  function toggleNav() {
    if (!window.location.href.includes('/cart') && window.innerWidth < 750) {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
      if (scrollTop > 110) {
        nav?.classList.add('show-nav');
        stickyHeaderEle?.classList.add('header-static');
      } else {
        nav?.classList.remove('show-nav');
        stickyHeaderEle?.classList.remove('header-static');
      }
    }
  }

  // Run on page load
  toggleNav();

  // Run on scroll
  window.addEventListener("scroll", toggleNav);
});